import { Pipe, PipeTransform, SecurityContext } from '@angular/core';

@Pipe({
  name: 'faNumber',
})
export class FaNumberPipe implements PipeTransform {
  constructor() {}

  transform(input: any): string {
    let result = '';
    if (input || input === 0) {
      input = input.toString();

      let i = 0;
      const len = input.length;
      let pos;

      const persianNumbers: string[] = [
        '۰',
        '۱',
        '۲',
        '۳',
        '۴',
        '۵',
        '۶',
        '۷',
        '۸',
        '۹',
      ];
      for (; i < len; i++) {
        if ((pos = persianNumbers[input.charAt(i)])) {
          result += pos;
        } else {
          result += input.charAt(i);
        }
      }
    }
    return result;
  }
}
